import http from "../requestBase";

const API_BASE = "api/Live";

function clearSiteDataAll() {
  var queryString = `${API_BASE}/ClearSiteData/all`;
  return http.get(queryString);
}

function clearSiteDataCombined(dataSelection) {
  var queryString = `${API_BASE}/ClearSiteData`;
  return http.post(queryString, JSON.stringify(dataSelection));
}

function getVersion() {
  return http.get(`${API_BASE}/Version`);
}

export default {
  clearSiteDataAll,
  clearSiteDataCombined,
  getVersion,
};



// WEBPACK FOOTER //
// ./src/services/Live/index.js